import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { class: "custom-upload-st2" }
const _hoisted_3 = ["id", "accept"]
const _hoisted_4 = { class: "s10" }
const _hoisted_5 = {
  id: "file-upload-title",
  class: "custom-upload-text uppercase"
}
const _hoisted_6 = {
  key: 0,
  class: "color-danger"
}
const _hoisted_7 = {
  id: "file-upload-title",
  class: "custom-upload-text-sm"
}

import { reactive, ref, onMounted, computed } from "vue";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'OnboardingUploadInput',
  props: {
        id: { type: String, required: true },
        label: { type: String, default: 'Fichier' },
        type: { type: String, default: 'IMAGE' },
        preview: { type: String },
        required: { type: Boolean, default: false }
    },
  emits: ["uploaded"],
  setup(__props, { emit: __emit }) {


    const emit = __emit
    const props = __props;

    const allExtensionsInfos = {
        'ALL': {
            extensions_allowed: '',
            extensions_labels: 'Tous les fichiers'
        },
        'VIDEO': {
            extensions_allowed: '.mp4,.avi,.mov,.mkv',
            extensions_labels: 'MP4, MOV, AVI, MKV'
        },
        'IMAGE': {
            extensions_allowed: '.jpg,.jpeg,.png,.gif,.webp,.svg',
            extensions_labels: 'JPG, PNG, GIF, Webp, SVG'
        },
    };
    const extensionsAllowed = ref('');
    const extensionsLabels = ref('');
    const formValue = reactive({
        file: '',
        file_name: '',
        file_preview: null as any,
    });

    onMounted(() => {
        extensionsAllowed.value = allExtensionsInfos[props.type as keyof typeof allExtensionsInfos].extensions_allowed;
        extensionsLabels.value = allExtensionsInfos[props.type as keyof typeof allExtensionsInfos].extensions_labels;
    });

    function onFileUploaded(event: any) {
        if (event.target.files.length > 0) {
            var reader = new FileReader();
            reader.onload = function(e) {
                formValue.file = event.target.files[0];
                formValue.file_name = event.target.files[0].name;
                formValue.file_preview = e.target!.result as string;
                emit('uploaded', formValue);
            }
            reader.readAsDataURL(event.target.files[0]);
        }
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    for: props.id,
    class: _normalizeClass(["custom-upload my-5", {'active': formValue.file}])
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        id: props.id,
        class: "display-none",
        type: "file",
        ref: "fichier_photo",
        onChange: _cache[0] || (_cache[0] = ($event: any) => (onFileUploaded($event))),
        accept: extensionsAllowed.value
      }, null, 40, _hoisted_3),
      _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "s5 custom-upload-img",
        style: {"background":"url('/images/empty.png')","background-size":"cover"}
      }, [
        _createElementVNode("img", {
          src: "/icons/icon-idcard-recto.svg",
          width: "45%",
          class: "icon-white"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(props.label), 1),
        (props.required)
          ? (_openBlock(), _createElementBlock("b", _hoisted_6, "*"))
          : _createCommentVNode("", true),
        _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("span", _hoisted_7, _toDisplayString(formValue.file_name ? formValue.file_name : "Charger l'image"), 1)
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "s5 right" }, [
        _createElementVNode("img", {
          src: "/icons/icon-upload.svg",
          class: "custom-upload-icon"
        })
      ], -1))
    ])
  ], 10, _hoisted_1))
}
}

})